/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


/* Content blur body class ----------------------- */
;(function(window, $) {
  $('.Header__MainNav a').parent().on('mouseenter', function() {
    $('body').addClass('blur-content')
  })
  $('.Header__MainNav').on('mouseleave', function() {
    $('body').removeClass('blur-content')
  })
  $(window).on('resize', function() {
    $('body').removeClass('blur-content')
  })
  $('body').on('click', '.ProductForm__AddToCart', function() {
    $( ".Header__Icon--flag" ).removeClass( "cart-empty-display-flag" );
    $( ".header-flag-div" ).removeClass( "cart-empty-reverse-row" );
    $( ".the-cart-icon" ).removeClass( "cart-empty-hidden" );
  });
  $('body').on('click', '.CartItem__Remove, .QuantitySelector__Button', function() {
    setTimeout(function () {
      if($('.Cart__Empty').length){
        $( ".Header__Icon--flag" ).addClass( "cart-empty-display-flag" );
        $( ".header-flag-div " ).addClass( "cart-empty-reverse-row" );
        $( ".the-cart-icon" ).addClass( "cart-empty-hidden" );
      }
    }, 2500);
    
  });  
  
})(window, jQuery)


// Event Tracking

document.addEventListener("DOMContentLoaded", () => {
  window.dataLayer = window.dataLayer || [];

  const dataVariables = (data) => {
    dataLayer.push({
      'event': data.dataset.event,
      'siteComponent': data.dataset.siteComponent,
      'componentLabel': data.dataset.componentLabel
    }); 
  }

  const links = document.querySelectorAll('.event-tracking');
  if (links.length > 0) {
    links.forEach(link => {
      link.addEventListener('click', () => {
        dataVariables(link)
      });
    });
  }

  const newsletter = document.getElementById('footer-newsletter');
  if (newsletter !== null) {
    const button = newsletter.querySelector('.Form__Submit');
    newsletter.addEventListener('submit', () => {
      dataVariables(button)
    });
  }

});

$(document).ready(function () {
  // Step 1: Bind click event to the first element
  $("div.Collapsible.sidemenu-search").on("click", function () {
    // Step 2: Click the button to close the drawer
    $('button.Drawer__Close[data-action="close-drawer"]').click();
    // Step 3: After a delay of 500 milli-second, click the search icon/link
    setTimeout(function () {
      var clickEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      });

      var element = document.querySelector(
        'a.Header__Icon[data-action="toggle-search"]'
      );
      if (element) {
        element.dispatchEvent(clickEvent);
      }
    }, 500);
  });

});


/* -----------------------------------------------
   Mobile Pinch-to-Zoom on Product Images
   - Two-finger pinch zooms the image in place
   - Pan while zoomed with two fingers
   - Smoothly animates back on release
   ----------------------------------------------- */
(function () {
  'use strict';

  var pinchReleaseTimer = null;

  function getFlickityInstance(slideshow) {
    if (!slideshow || !window.Flickity || !Flickity.data) return null;
    return Flickity.data(slideshow);
  }

  function disableCarouselDrag(slideshow) {
    var flickity = getFlickityInstance(slideshow);

    if (flickity && flickity.isActive) {
      flickity.unbindDrag();
    }
  }

  function abortCarouselDrag(slideshow) {
    var flickity = getFlickityInstance(slideshow);

    if (!flickity || !flickity.isActive) {
      return;
    }

    if (flickity.isPointerDown && flickity._pointerDone) {
      flickity._pointerDone();
    }

    if (flickity.viewport) {
      flickity.viewport.classList.remove('is-pointer-down');
    }

    flickity.isDragging = false;
    delete flickity.previousDragX;
    delete flickity.isFreeScrolling;

    if (typeof flickity.positionSliderAtSelected === 'function') {
      flickity.positionSliderAtSelected();
    }
  }

  function enableCarouselDrag(slideshow) {
    var flickity = getFlickityInstance(slideshow);

    if (flickity && flickity.isActive) {
      flickity.bindDrag();
    }
  }

  function initPinchToZoom() {
    var slideshow = document.querySelector('.Product__Slideshow');
    if (!slideshow) return;

    var isMobile = window.matchMedia('(max-width: 999px)').matches;
    if (!isMobile) return;

    var slides = slideshow.querySelectorAll('.Product__SlideItem--image');
    slides.forEach(function (slide) {
      setupPinchZoom(slide, slideshow);
    });

    // Re-check on breakpoint changes
    document.addEventListener('breakpoint:changed', function () {
      var nowMobile = window.matchMedia('(max-width: 999px)').matches;
      if (nowMobile) {
        var newSlides = slideshow.querySelectorAll('.Product__SlideItem--image');
        newSlides.forEach(function (s) {
          if (!s._pinchZoomInit) setupPinchZoom(s, slideshow);
        });
      }
    });
  }

  function setupPinchZoom(slideItem, slideshow) {
    if (slideItem._pinchZoomInit) return;
    slideItem._pinchZoomInit = true;

    var img = slideItem.querySelector('img');
    if (!img) return;

    var state = {
      isPinching: false,
      startDistance: 0,
      startScale: 1,
      scale: 1,
      translateX: 0,
      translateY: 0,
      startMidX: 0,
      startMidY: 0,
      lastMidX: 0,
      lastMidY: 0,
      originX: 50,
      originY: 50
    };

    // Prevent default only when pinching (2 fingers)
    slideItem.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        e.stopPropagation();

        if (pinchReleaseTimer) {
          clearTimeout(pinchReleaseTimer);
          pinchReleaseTimer = null;
        }

        abortCarouselDrag(slideshow);
        disableCarouselDrag(slideshow);
        state.isPinching = true;
        state.startDistance = getDistance(e.touches[0], e.touches[1]);
        state.startScale = state.scale;

        var rect = img.getBoundingClientRect();
        var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

        state.startMidX = midX;
        state.startMidY = midY;
        state.lastMidX = midX;
        state.lastMidY = midY;

        // Set transform origin to the pinch center (as percentage of the image)
        state.originX = ((midX - rect.left) / rect.width) * 100;
        state.originY = ((midY - rect.top) / rect.height) * 100;

        // Clamp origin
        state.originX = Math.max(0, Math.min(100, state.originX));
        state.originY = Math.max(0, Math.min(100, state.originY));

        img.style.transformOrigin = state.originX + '% ' + state.originY + '%';
        img.style.transition = 'none';
        img.style.willChange = 'transform';
        slideItem.style.zIndex = '10';
      }
    }, { passive: false });

    slideItem.addEventListener('touchmove', function (e) {
      if (!state.isPinching || e.touches.length < 2) return;
      e.preventDefault();

      var currentDistance = getDistance(e.touches[0], e.touches[1]);
      var newScale = state.startScale * (currentDistance / state.startDistance);

      // Clamp scale between 1 and 3
      state.scale = Math.max(1, Math.min(3, newScale));

      var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

      // Calculate pan offset (only effective when zoomed in)
      if (state.scale > 1) {
        state.translateX += (midX - state.lastMidX);
        state.translateY += (midY - state.lastMidY);
      }

      state.lastMidX = midX;
      state.lastMidY = midY;

      applyTransform(img, state);
    }, { passive: false });

    slideItem.addEventListener('touchend', function (e) {
      if (!state.isPinching) return;

      // If no more touches or only 1 finger left, release the zoom
      if (e.touches.length < 2) {
        e.stopPropagation();
        state.isPinching = false;

        // Animate back to original
        img.style.transition = 'transform 0.3s cubic-bezier(0.2, 0, 0.2, 1)';
        state.scale = 1;
        state.translateX = 0;
        state.translateY = 0;
        applyTransform(img, state);

        // Cleanup after animation
        setTimeout(function () {
          img.style.willChange = '';
          img.style.transition = '';
          img.style.transformOrigin = '';
          slideItem.style.zIndex = '';
        }, 300);

        pinchReleaseTimer = setTimeout(function () {
          enableCarouselDrag(slideshow);
          pinchReleaseTimer = null;
        }, 350);
      }
    });

    slideItem.addEventListener('touchcancel', function (e) {
      if (!state.isPinching) return;
      e.stopPropagation();
      state.isPinching = false;

      img.style.transition = 'transform 0.3s cubic-bezier(0.2, 0, 0.2, 1)';
      state.scale = 1;
      state.translateX = 0;
      state.translateY = 0;
      applyTransform(img, state);

      setTimeout(function () {
        img.style.willChange = '';
        img.style.transition = '';
        img.style.transformOrigin = '';
        slideItem.style.zIndex = '';
      }, 300);

      pinchReleaseTimer = setTimeout(function () {
        enableCarouselDrag(slideshow);
        pinchReleaseTimer = null;
      }, 350);
    });
  }

  function getDistance(touch1, touch2) {
    var dx = touch1.clientX - touch2.clientX;
    var dy = touch1.clientY - touch2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function applyTransform(img, state) {
    img.style.transform = 'scale(' + state.scale + ') translate(' + (state.translateX / state.scale) + 'px, ' + (state.translateY / state.scale) + 'px)';
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPinchToZoom);
  } else {
    initPinchToZoom();
  }

  // Also re-init on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', initPinchToZoom);
})();


/* -----------------------------------------------
   Product Tile Carousels (mobile + desktop)
   - Initializes Flickity on .ProductThumbCarousel elements
   - Uses watchCSS so each breakpoint variant only initializes
     when its media query is matched (set via :after { content: 'flickity' })
   - Re-runs after AJAX collection reload, Shopify section reload, and
     when product recommendations / recently viewed sections load in
   ----------------------------------------------- */
(function ($) {
  if (!$ || typeof $.fn === 'undefined' || typeof $.fn.flickity !== 'function') {
    return;
  }

  var carouselOptions = {
    prevNextButtons: true,
    pageDots: false,
    wrapAround: true,
    cellAlign: 'center',
    watchCSS: true,
    arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 }
  };

  function initProductThumbCarousels(scope) {
    var $scope = scope ? $(scope) : $(document);
    var $carousels = $scope.find('.ProductThumbCarousel').addBack('.ProductThumbCarousel');

    $carousels.each(function () {
      var $carousel = $(this);
      if ($carousel.data('flickity-initialized')) {
        return;
      }
      $carousel.flickity(carouselOptions);
      $carousel.data('flickity-initialized', true);
    });
  }

  $(window).on('load', function () {
    initProductThumbCarousels();
  });

  // Re-init after AJAX-loaded content (collection filters/sort, product
  // recommendations, recently viewed, etc.). New nodes are appended to the
  // DOM and need their carousels initialized.
  document.addEventListener('theme:loading:end', function () {
    initProductThumbCarousels();
  });

  // Theme editor / Shopify section reloads
  document.addEventListener('shopify:section:load', function (event) {
    initProductThumbCarousels(event.target);
  });
})(window.jQuery);